import fetch from "../fetch";

export default ({ values, dealCode }) => {
  return fetch({
    path: dealCode ? `/abs/deals/${dealCode}` : "/abs/deals",
    method: dealCode ? "PUT" : "POST",
    data: values
  });
};
